export default __webpack_public_path__ + "3838c17a223de41b826dcdf6694e77d2.png";